import { AbstractModalService } from './AbstractModalService';
import { IModalService } from './modalServiceTypes';

export class ModalServiceStub
	extends AbstractModalService
	implements IModalService
{
	constructor() {
		super();

		(window as any).showModal = (data: any) => {
			this.showModal(data, (result) => {
				console.log('Modal result:', result);
			});
		};

		(window as any).reply = (data: any) => {
			this.replyToCurrentModal({ isAccepted: true, ...data });
		};
	}
}
